import React, { useState, useContext } from "react";
import { Alert, Box, Button, Container, TextField, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router";
import currency from "currency.js";
import { getAmountWithTxnFee } from "../../common/util";
import { UserContext } from "../../context/UserContext";

export default function TouchAmountEntry(props) {
  const { payment, hideFees } = props;

  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const [error, setError] = useState("");

  const handleChange = (cents, includeFees) => {
    const amount = currency(cents, { fromCents: true }).value;
    const total =
      String(payment.includeFees) === "true"
        ? getAmountWithTxnFee(amount, user.config?.fees)
        : amount;
    props.onChange({ amount, includeFees, total });
  };

  const getButton = (key) => {
    return (
      <Button
        variant="contained"
        onClick={(e) => {
          if (key === "⌫") {
            handleChange(`${currency(payment.amount).intValue}`.slice(0, -1), payment.includeFees);
          } else {
            const newAmount = `${currency(payment.amount).intValue}${key}`;
            console.log(newAmount);
            handleChange(newAmount, payment.includeFees);
          }
        }}
        sx={{
          flex: "1 1 0",
          height: "5rem",
          width: "100%",
          minWidth: 0,
          fontWeight: "700",
          fontSize: "2rem",
          backgroundColor: "#DEDEDE",
          color: "#333",
          "&:hover": {
            backgroundColor: "#DEDEDE",
          },
        }}
      >
        {key}
      </Button>
    );
  };
  const isFeeEnabledOnAccount = user.config?.transferFees === "false" ? false : true;
  const showFees = !hideFees && +payment.amount > 0 && isFeeEnabledOnAccount;

  return (
    <Container maxWidth="sm" disableGutters>
      <Box py={2}>
        {error && (
          <Box>
            <Alert severity="error">{error}</Alert>
          </Box>
        )}
        <Box>
          <Box
            textAlign="center"
            sx={{
              borderBottom: "2px solid #DDD",
              display: "flex",
              justifyContent: "space-between",
              gap: "2rem",
            }}
          >
            <Typography
              sx={{ fontSize: "2.5rem", flexGrow: 1, paddingLeft: showFees ? "5rem" : 0 }}
            >
              {currency(payment.amount).format()}
            </Typography>
            {showFees && (
              <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                <Typography sx={{ fontSize: "1.25rem", lineHeight: "1" }}>
                  {currency(payment.total).format()}
                </Typography>
                <Typography variant="caption" color="textSecondary" sx={{ fontSize: "0.65rem" }}>
                  with fees
                </Typography>
              </Box>
            )}
          </Box>
          <Box my={2} sx={{ display: "flex", gap: "1rem", justifyContent: "space-between" }}>
            {[7, 8, 9].map((num) => getButton(num))}
          </Box>
          <Box my={2} sx={{ display: "flex", gap: "1rem", justifyContent: "space-between" }}>
            {[4, 5, 6].map((num) => getButton(num))}
          </Box>
          <Box my={2} sx={{ display: "flex", gap: "1rem", justifyContent: "space-between" }}>
            {[1, 2, 3].map((num) => getButton(num))}
          </Box>
          <Box mt={2} sx={{ display: "flex", gap: "1rem", justifyContent: "space-between" }}>
            {["⌫", 0, "00"].map((num) => getButton(num))}
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
